import { useEffect } from "react";

// import JSON
import projectPageJson from '../../configs/project.json';

export default function Projects() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div className="ProjectPage">
            <div className="ProjectPage-Title">
                My Projects
            </div>
            <div className="ProjectPage-Container-Outer">
            {
                projectPageJson.map((projectData, index) => {
                    return (
                        <SiteCell
                            keyVal={"projectData"+index}
                            images={projectData["images"]}
                            title={projectData["title"]}
                            buttonInfo={projectData["buttonInfo"]}
                            buttonInactivity={projectData["buttonInactivity"]}
                            secondButton={projectData["secondButton"]}
                            secondButtonInfo={projectData["secondButtonInfo"]}
                            accessSite={projectData["accessSite"]}
                            accessSite2={projectData["accessSite2"]}
                            text1={projectData["text1"]}
                            text2={projectData["text2"]}
                        />
                    )
                })
            }
            </div>
        </div>
    );
}

function SiteCell({ images, title, text1, text2, buttonInfo, buttonInactivity, secondButton, secondButtonInfo, accessSite, accessSite2, delay, opacityV, keyVal, ...props }) {
    return (
        <div key={keyVal} className="ProjectPage-Item-Container-Outer">
            <div className="ProjectPage-Item-Header-Container">
                <div className="ProjectPage-Item-Title">
                    {title}
                </div>
                <div className="ProjectPage-Item-Image-Container">
                    <img alt="" className="ProjectPage-Item-Image" loading="lazy" src={images} />
                </div>
            </div>
            <div className="ProjectPage-Item-Content-Container">
                <div className="ProjectPage-Item-Summary-Container">
                    <div className="ProjectPage-Item-Summary">{text1}</div>
                    <div className="ProjectPage-Item-Summary">{text2}</div>
                </div>
                <div className="ProjectPage-Item-Button-Container-Outer">
                    <div className="ProjectPage-Item-Button-Container-Inner">
                        <a href={accessSite} className={`ProjectPage-Item-Button ${buttonInactivity ? "disable" : ""}`} target="noreferrer">
                            {buttonInfo}
                        </a>
                        {
                            secondButton === false ? "" :
                            <a href={accessSite2} className="ProjectPage-Item-Button" target="noreferrer">
                                {secondButtonInfo}
                            </a>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}